import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSintEustatius = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1788)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23655 21.913C7.16245 23.2295 9.49106 24 12 24C14.5089 24 16.8376 23.2295 18.7634 21.913L12 20.8695L5.23655 21.913Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7634 2.08697C16.8376 0.770484 14.5089 0 12 0C9.49106 0 7.16236 0.770484 5.23655 2.08697L12 3.13045L18.7634 2.08697Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23655 21.913C7.16245 23.2295 9.49106 24 12 24C14.5089 24 16.8376 23.2295 18.7634 21.913L12 20.8695L5.23655 21.913Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7634 2.08697C16.8376 0.770484 14.5089 0 12 0C9.49106 0 7.16236 0.770484 5.23655 2.08697L12 3.13045L18.7634 2.08697Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9694 11.2174C23.6851 7.51378 21.4348 3.91302 18.7635 2.08691H5.23655C2.27705 4.11009 0.269532 7.42359 0.025219 11.2174L12 12L23.9694 11.2174Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.025219 12.7826C0.269532 16.5765 2.277 19.8899 5.2365 21.9131H18.7634C21.7231 19.89 23.7304 16.5765 23.9747 12.7826L12 12L0.025219 12.7826Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9694 11.2173H12.7826V1.56522H11.2174V11.2173H0.0252656C0.008625 11.4761 0 11.737 0 12C0 12.2629 0.00857813 12.5238 0.0252187 12.7826H11.2174V22.4348H12.7826V12.7826H23.9748C23.9914 12.5238 24 12.2629 24 12C24 11.739 23.9895 11.4779 23.9694 11.2173Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.69566 12L11.9999 7.40897L19.3043 12L11.9999 16.5911L4.69566 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 14.087H17.2174L15.1305 10.9565L14.087 12L13.0435 11.4783L12 13.0435H9.91303L8.86955 12L7.82611 14.087Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 8.86954L12.259 9.66665H13.0971L12.4191 10.1594L12.6781 10.9565L12 10.4639L11.3219 10.9565L11.5809 10.1594L10.9029 9.66665H11.741L12 8.86954Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.09723L2.60869 12L12 17.9028L21.3913 12L12 6.09723ZM5.55 12L12 7.94593L18.45 12L12 16.0541L5.55 12Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1788",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSintEustatius;
